import React from 'react'
import * as S from './styles'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ColumnChart from 'presentation/shared/components/Charts/Column'
import moment, { now } from 'moment-timezone'

type GraphComparisonCardProps = {
  title: string
  value: string
  textInfo: string
  variant: 'indicatorPositive' | 'indicatorNegative' | 'indicatorEqual'
  chartValues: {
    lastYear: number
    currentYear: number
  }
}

export const GraphComparisonCard = ({
  title,
  value,
  variant,
  textInfo,
  chartValues
}: GraphComparisonCardProps) => {
  const date = now()
  const lastYear = String(moment(date).year() - 1)
  const currentYear = String(moment(date).year())

  const graphColorsByVariant = {
    indicatorPositive: '#6EB471',
    indicatorNegative: '#D65F5F',
    indicatorEqual: '#3C9ED3'
  }

  return (
    <S.StyledCardNew>
      <S.GraphComparisonCardHeader>
        <HeadingNew as="h6" color="neutral800" size="xxsmall" weight="bold">
          {title}
        </HeadingNew>
        <S.ValueContainer
          variant={
            variant === 'indicatorPositive'
              ? 'positive'
              : variant === 'indicatorNegative'
              ? 'negative'
              : 'equal'
          }
          style={{
            fontSize: isNaN(Number(value.replace('%', ''))) ? '14px' : ''
          }}
        >
          {value}
        </S.ValueContainer>
        {textInfo && <S.textInfo>{textInfo}</S.textInfo>}
      </S.GraphComparisonCardHeader>
      <S.GraphComparisonCardContent>
        <ColumnChart
          series={[
            {
              data: [
                {
                  x: lastYear,
                  y: chartValues.lastYear,
                  fillColor: '#0000004D'
                },
                {
                  x: currentYear,
                  y: chartValues.currentYear,
                  fillColor: graphColorsByVariant[variant]
                }
              ]
            }
          ]}
          labels={[lastYear, currentYear]}
        />
      </S.GraphComparisonCardContent>
    </S.StyledCardNew>
  )
}
